var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"answered"},[_c('h3',[_vm._v("You've answered this question!")]),_vm._v(" "),_c('a',{staticClass:"m-btn m-btn--left m-btn__secondary",on:{"click":function($event){return _vm.back();}}},[_c('span',{staticClass:"m-btn m-btn__back",staticStyle:{"display":"inline-block","margin-top":"-0.4em"}}),_vm._v("Go back")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ca25352","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Answered.vue
// module id = null
// module chunks = 